var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{attrs:{"flat":"","no-title":"","full-width":"","max":_vm.today,"locale":_vm.locale},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }